import { Flex, Box, Text } from '@spothero/ui';
import React from 'react';
import { isSortByRelevanceExperimentEnabled } from 'utils/visual-flags';
const compactStyles = {
    width: 'fit-content',
    minWidth: 'unset',
    marginLeft: {
        base: 0,
        tablet: '-0.5rem',
    },
    marginTop: {
        base: '-0.5rem',
        tablet: '-1rem',
    },
    marginBottom: {
        base: 0,
        tablet: '0.75rem',
    },
    borderTopLeftRadius: 0,
    borderTopRightRadius: '0.5rem',
    zIndex: 100,
};
const partialStyles = {
    marginLeft: '-1rem',
    marginTop: '-0.5rem',
    marginBottom: '0.5rem',
    borderTopRightRadius: '0.5rem',
    borderBottomRightRadius: '0.5rem',
};
const nonPartialStyles = {
    borderTopLeftRadius: '0.5rem',
    borderBottomRightRadius: '0.5rem',
};
const DynamicVisualFlag = ({ isPartialBanner, title, isCompact, }) => {
    if (!isSortByRelevanceExperimentEnabled()) {
        return null;
    }
    return (<Flex>
            <Box paddingX="4" paddingY="1px" minWidth="126px" textAlign="center" backgroundColor="black" color="white" {...(isPartialBanner ? partialStyles : nonPartialStyles)} {...(isCompact ? compactStyles : {})} data-testid={`DynamicVisualFlag-${encodeURIComponent(title)}`}>
                <Text fontSize={isCompact ? 'xs' : 'sm'} fontWeight="semibold">
                    {title}
                </Text>
            </Box>
        </Flex>);
};
export default DynamicVisualFlag;
